var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgCarrotRight = function SvgCarrotRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.758 6.55a1.05 1.05 0 000 1.485l4.157 4.158-4.157 4.157a1.05 1.05 0 101.485 1.485l4.9-4.9a1.05 1.05 0 000-1.485l-4.9-4.9a1.05 1.05 0 00-1.485 0z",
    fill: "#9CA6AD"
  })));
};

export default SvgCarrotRight;